// react
import React from 'react'

// css
import '../../css/pages/ImportTopics.styl'

// components
import {
  Columns,
  Button,
  BUTTON_THEME,
  CircularLoader,
  Input,
} from '@st-operations/uikit/src/v2/index.js'
import Header from '_components/header/index.jsx'

// lib
import searchEntities from '../lib/searchEntities.js'
import { eachSeries } from 'async-es'

// Import Topics Page
class ImportTopicsPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      existing_topics: [],
      loading: false,
      new_topics: [],
      query: '',
      topics_found: true,
    }
  }

  checkTopicsExist = (topics, callback) => {
    // see if topic already exist in db
    eachSeries(
      topics,
      (item, next) => {
        let path
        if (item.mid[1] == 'm') {
          path = `/topics/m/${item.mid.slice(3)}`
        } else if (item.mid[1] == 'g') {
          path = `/topics/g/${item.mid.slice(3)}`
        }

        window._api.get(path, (error, topic) => {
          if (error) {
            toast.error(error.message)
          } else {
            if (topic._id) {
              // set flag if topic exists
              item.exist = true
            }
            next()
          }
        })
      },
      (error) => {
        if (error) {
          toast.error(error.message)
        } else callback()
      }
    )
  }

  importTopic = (e, name, item) => {
    // attempt to import topic
    this.setState({ loading: true })
    window._api.post(
      '/topics/import',
      {
        google_trends: item,
      },
      (error) => {
        if (error) {
          toast.error(error.message)
        } else {
          toast('Topic has been added to the database!')
          this.setState({ loading: false })
        }
      }
    )
  }

  onSearch = (value) => {
    let query = value
    this.setState({
      existing_topics: [],
      new_topics: [],
      query,
    })

    // debounce
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      this.setState({ query }, this.search)
    }, 500)
  }

  search = () => {
    const { query } = this.state

    // check if topic exist in mongodb already
    if (query && query.length > 0) {
      this.setState({ loading: true })
      searchEntities('topics', { limit: 50, query }, (topics) => {
        if (topics.length > 0) {
          topics.sort((a, b) => (a.name > b.name ? 1 : -1))
          this.setState({ existing_topics: topics, topics_found: true })
        } else {
          this.setState({ topics_found: false })
        }
        this.setState({ loading: false })
      })
    }
  }

  searchGoogleTrends = () => {
    const { query } = this.state

    // search on google trends
    this.setState({ loading: true })
    window._api.get('/topics/search-google-trends', { query }, (error, resp) => {
      if (error) {
        toast.error(error.message)
      } else {
        this.checkTopicsExist(resp.default.topics, () => {
          // set google trend results
          this.setState({
            loading: false,
            new_topics: resp.default.topics.filter((item) => !item.exist),
          })
        })
      }
    })
  }

  render() {
    const { loading, topics_found, query } = this.state
    const { existing_topics, new_topics } = this.state

    return (
      <div id="import-topics-page">
        <If condition={loading}>
          <CircularLoader />
        </If>

        <Header title="Import Topics" />

        <Input onChange={this.onSearch} placeholder="Search for Topics to be added" value={query} />

        <If condition={query.length > 0}>
          <If condition={!topics_found}>
            <h4>{`'${query}' is not in the database`}</h4>
          </If>

          <If condition={topics_found}>
            <h4>{`Existing Topics in the database related to '${query}':`}</h4>
            <Columns classes={{ root: 'topics-page-column' }}>
              <div className="column" style={{ textAlign: 'left' }}>
                <For each="topic" of={existing_topics.slice(0, existing_topics.length / 2)}>
                  <div style={{ marginTop: '5px' }} key={index}>
                    {topic.name}
                  </div>
                </For>
              </div>
              <div className="column" style={{ textAlign: 'left' }}>
                <For each="topic" of={existing_topics.slice(existing_topics.length / 2)}>
                  <div style={{ marginTop: '5px' }} key={index}>
                    {topic.name}
                  </div>
                </For>
              </div>
            </Columns>
          </If>

          <h4>{"Don't see the topic you searched for?"}</h4>
          <Button
            theme={BUTTON_THEME.SECONDARY}
            onClick={this.searchGoogleTrends}
          >{`Search '${query}' on Google Trends`}</Button>

          <If condition={new_topics.length > 0}>
            <h4>Here are the results found on Google Trends:</h4>
            <For each="topic" of={new_topics}>
              <div key={index}>
                <Button onClick={this.importTopic} value={topic}>
                  Import Topic
                </Button>
                <span style={{ marginTop: '5px' }}>{`${topic.title} (${topic.type})`}</span>
              </div>
            </For>
          </If>
        </If>
      </div>
    )
  }
}

// export
export default ImportTopicsPage
